import React from "react";
import { Card, CardBody } from "reactstrap";
import "./style.scss";

interface DomainInfoCardProps {
  label: string;
  value: string | number;
  icon: any;
}

const DomainInfoCard: React.FC<DomainInfoCardProps> = ({
  label,
  value,
  icon,
}) => {
  return (
    <Card className="dic-card">
      <CardBody className="d-flex align-items-center gap-3 p-2">
        <div className="dic-icon">{icon}</div>
        <span className="dic-label">{label}</span>
        <span className="dic-value">{value}</span>
      </CardBody>
    </Card>
  );
};

export default DomainInfoCard;
